import { render, staticRenderFns } from "./EnterCompetition.vue?vue&type=template&id=5f58f7a7&scoped=true&"
import script from "./EnterCompetition.vue?vue&type=script&lang=js&"
export * from "./EnterCompetition.vue?vue&type=script&lang=js&"
import style0 from "./EnterCompetition.vue?vue&type=style&index=0&id=5f58f7a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f58f7a7",
  null
  
)

export default component.exports